export const DATADOG_CONFIG = {
  applicationId: 'b2acd8b1-85b3-4079-b1c9-a9ff7ce1a1c8',
  clientToken: 'pub904f45341cad03755ce305a66c56ca3d',
  site: 'datadoghq.eu',
} as const
